if (libraries.knockoutValidation) {
  ko.validation.registerExtenders();
}
